import { render, staticRenderFns } from "./OperationDetails.vue?vue&type=template&id=07ed6672&"
import script from "./OperationDetails.vue?vue&type=script&lang=js&"
export * from "./OperationDetails.vue?vue&type=script&lang=js&"
import style0 from "./OperationDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports